declare const _queryResult: unique symbol;
export type TypedQuery<TResult> = string & {
  readonly [_queryResult]?: TResult;
};
export function typedQuery<TResult>(query: string): TypedQuery<TResult> {
  return query as TypedQuery<TResult>;
}
/** Extracts the result type from a TypedQuery constant. */
export type QueryResult<Q> = Q extends TypedQuery<infer R> ? R : never;
